const MAP_LOAD_TIMEOUT_MS = 12000;

export const initContactMaps = (): void => {
  const containers = Array.from(document.querySelectorAll<HTMLElement>('[data-contact-map]'));

  containers.forEach((container) => {
    const prompt = container.querySelector<HTMLElement>('.contact__map-prompt');
    const loadButton = container.querySelector<HTMLButtonElement>('[data-contact-map-load]');
    const status = container.querySelector<HTMLElement>('[data-contact-map-status]');
    const fallback = container.querySelector<HTMLAnchorElement>('[data-contact-map-fallback]');

    if (!prompt || !loadButton || !status || !fallback) {
      return;
    }

    let attempt = 0;

    loadButton.addEventListener('click', () => {
      const currentAttempt = ++attempt;
      const controller = new AbortController();
      const surface = document.createElement('div');

      surface.className = 'contact__map-surface';
      surface.setAttribute('aria-hidden', 'true');
      container.prepend(surface);
      container.classList.remove('contact__map-canvas--inactive');
      container.classList.add('contact__map-canvas--loading');
      status.textContent = 'Karte wird geladen …';
      status.hidden = false;
      fallback.hidden = true;
      loadButton.disabled = true;
      loadButton.hidden = true;

      const fail = (): void => {
        if (currentAttempt !== attempt) {
          return;
        }

        ++attempt;
        window.clearTimeout(timeout);
        controller.abort();
        surface.remove();
        container.classList.remove('contact__map-canvas--loading');
        container.classList.add('contact__map-canvas--inactive');
        status.textContent = 'Die Karte konnte nicht geladen werden. Bitte versuchen Sie es erneut.';
        fallback.hidden = false;
        loadButton.textContent = 'Erneut versuchen';
        loadButton.disabled = false;
        loadButton.hidden = false;
      };

      const timeout = window.setTimeout(fail, MAP_LOAD_TIMEOUT_MS);

      void import('./contact-map-instance')
        .then(({ createContactMap }) => {
          if (currentAttempt !== attempt) {
            return;
          }

          return createContactMap(container, surface, controller.signal);
        })
        .then(() => {
          if (currentAttempt !== attempt) {
            return;
          }

          window.clearTimeout(timeout);
          container.classList.remove('contact__map-canvas--loading');
          surface.removeAttribute('aria-hidden');
          prompt.hidden = true;
        })
        .catch(fail);
    });
  });
};
